import { render, staticRenderFns } from "./cModalEditNote.vue?vue&type=template&id=5bc85cc3"
import script from "./cModalEditNote.vue?vue&type=script&lang=js"
export * from "./cModalEditNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports